export const FETCHMODULE = '@module/FETCHMODULE';
export const CHANGESTATUSMODULE = '@module/CHANGESTATUSMODULE';
export const DELETEMODULE = '@module/DELETEMODULE';